// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBpsn9dKFYAaBGnrrqZfsbhqwjUr2grWkw",
  authDomain: "pupnbee-bee84.firebaseapp.com",
  projectId: "pupnbee-bee84",
  storageBucket: "pupnbee-bee84.appspot.com",
  messagingSenderId: "992839935214",
  appId: "1:992839935214:web:50e7af87b10d670f4b7fff",
  measurementId: "G-FP58SND90G",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, db, auth, storage };
